import angular from 'angular'
import distributionService from 'distributionService'
import routers from './routers.js'
import modalDistributionCtrl from './modalDistributionCtrl.js'
import { distribution } from 'redevConfig'

const list = (distribution && distribution.list) || ''
const distributionCtrl = list ? require(`redevelopment/outputManage/distribution/${list.controllerName}`) : require('./distributionCtrl.js')
export default angular
    .module('outputManage.stock.distribution', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('distributionCtrl', distributionCtrl.default)
    .controller('modalDistributionCtrl', modalDistributionCtrl)
    .service('distributionService', distributionService)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/distribution/index.js